export var EMBEDDED_CONFLUENCE_MODE = /*#__PURE__*/function (EMBEDDED_CONFLUENCE_MODE) {
  EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
  EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
  return EMBEDDED_CONFLUENCE_MODE;
}({});